import React from "react";
type Props = {
  expanded: boolean;
  children: React.ReactNode;
};
export default function Collapse({ expanded, children }: Props) {
  return expanded ? <div>{children}</div> : null;
}
